// extracted by mini-css-extract-plugin
export default {"comingSoon":"comingSoon_comingSoon__vyXnz","tag":"comingSoon_tag__BDlF4"};